import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { Link } from 'base-ui'

import { useSellerModalContext } from '../../../seller/components/seller-modal/SellerModalContext'

export const ExperimentCtaButtonOnAllCswProductBuyBoxSellerInfo: FC<{
  crossSellProduct: CrossSellProduct | undefined
}> = ({ crossSellProduct }) => {
  const { showSellerModal } = useSellerModalContext()

  if (!crossSellProduct) {
    return null
  }

  return (
    <div className="px-2 text-center text-xs text-dark-primary-low">
      <FormattedMessage id="message.soldAndShipped.partnerCrossSell" />

      <Link<'button'>
        className="pl-1 text-dark-primary-low underline"
        data-clientside-hook={`open-seller-modal--${crossSellProduct.sellerId}`}
        data-qa-id="seller-name"
        onClick={() => {
          showSellerModal({
            productUpid: crossSellProduct.id,
            sellerId: crossSellProduct.sellerId,
          })
        }}
        slots={{ root: 'button' }}
        type="button"
      >
        {crossSellProduct.sellerName}
      </Link>
    </div>
  )
}
